import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";

export type ProjectType = {
  projectTypeId: string;
  organisationId: string;
  projectTypeName: string;
};

export type ProjectTypesResponse = ResponseType<ProjectType[]>;

function useAllProjectTypesQuery(enabled = true) {
  return useQuery<
    AxiosResponseAndError<ProjectTypesResponse>["response"],
    AxiosResponseAndError<ProjectTypesResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.projectTypes],
    queryFn: async () =>
      await ApiRequest.get(requestURLs.project + "/project-types"),
    enabled: enabled,
    staleTime: 60000,
  });
}

export default useAllProjectTypesQuery;
